import SePlainAlertDialog from './SePlainAlertDialog';

export const seAlert = (text: string) => {
    const dialog = new SePlainAlertDialog();
    dialog.textContent = text;
    dialog.choices = ['Ok'];
    dialog.open();
};

window.seAlert = seAlert;

declare global {
    interface Window {
        seAlert(text: string);
    }
}
